export function getView(type) {
  return type?.startsWith('video/')
}
